































































import { GLOBAL_MESSAGE } from "@/helpers/hooks/useGlobalMessage";
import { useGlobalState } from "@/helpers/hooks/useGlobalState";
import {
  computed,
  defineComponent,
  onMounted,
  onUnmounted,
  ref,
  watch
} from "@vue/composition-api";

export default defineComponent({
  props: {
    isShowOwnEventTimeline: {
      type: Boolean,
      default: true
    },
    isShowCompetitorEventTimeline: {
      type: Boolean,
      default: true
    },
    isShowUniversityEventTimeline: {
      type: Boolean,
      default: true
    },
    isShowStudentTrendTimeline: {
      type: Boolean,
      default: true
    },
    axisBarHeight: {
      type: Number,
      required: true
    },
    ownEventTimelineHeight: {
      type: Number,
      default: -1
    },
    competitorEventTimelineHeight: {
      type: Number,
      default: -1
    },
    universityEventTimelineHeight: {
      type: Number,
      default: -1
    },
    studentTrendTimelineHeight: {
      type: Number,
      default: -1
    }
  },
  setup(props) {
    const { messages } = useGlobalState(GLOBAL_MESSAGE);
    const containerHeight = ref(0);
    const borderBottomHeight = ref(1);

    const ownEventPaneHeight = computed(() => {
      const minHeight = 120 + props.axisBarHeight;
      const height = props.ownEventTimelineHeight + props.axisBarHeight;
      const maxHeight = containerHeight.value * 0.3;

      return props.isShowOwnEventTimeline
        ? Math.max(minHeight, Math.min(maxHeight, height))
        : props.axisBarHeight;
    });

    const competitorEventPaneHeight = computed(() => {
      const maxHeight = props.isShowUniversityEventTimeline
        ? variableEventPaneMaxHeightWhenIsShowOtherSide.value
        : variableEventPaneMaxHeight.value;

      const height =
        props.competitorEventTimelineHeight +
        props.axisBarHeight +
        borderBottomHeight.value;

      return props.isShowCompetitorEventTimeline
        ? Math.min(maxHeight, height)
        : props.axisBarHeight;
    });

    const universityEventPaneHeight = computed(() => {
      const maxHeight = props.isShowCompetitorEventTimeline
        ? variableEventPaneMaxHeightWhenIsShowOtherSide.value
        : variableEventPaneMaxHeight.value;

      const height =
        props.universityEventTimelineHeight +
        props.axisBarHeight +
        borderBottomHeight.value;

      return props.isShowUniversityEventTimeline
        ? Math.min(maxHeight, height)
        : props.axisBarHeight;
    });

    const studentTrendPaneHeight = computed(() => {
      const height = containerHeight.value * 0.2;

      return props.isShowStudentTrendTimeline ? height : props.axisBarHeight;
    });

    const extraPaneHeight = computed(() => {
      return (
        containerHeight.value -
        ownEventPaneHeight.value -
        competitorEventPaneHeight.value -
        universityEventPaneHeight.value -
        studentTrendPaneHeight.value
      );
    });

    // NOTE: 他社もしくは大学ペインの最大の高さ(片方のみ表示の時)
    const variableEventPaneMaxHeight = computed(() => {
      return (
        containerHeight.value -
        ownEventPaneHeight.value -
        studentTrendPaneHeight.value -
        props.axisBarHeight -
        borderBottomHeight.value
      );
    });

    // NOTE: 他社もしくは大学のペインの最大の高さ(両方表示の時)
    const variableEventPaneMaxHeightWhenIsShowOtherSide = computed(() => {
      return (
        (containerHeight.value -
          ownEventPaneHeight.value -
          studentTrendPaneHeight.value -
          borderBottomHeight.value) /
        2
      );
    });

    const updateContainerHeight = () => {
      const splitViewContainer = document.getElementById("splitViewContainer");
      if (splitViewContainer) {
        containerHeight.value = splitViewContainer.clientHeight;
      }
    };

    watch(messages, () => {
      updateContainerHeight();
    });

    onMounted(() => {
      updateContainerHeight();
      window.addEventListener("resize", updateContainerHeight);
    });

    onUnmounted(() => {
      window.removeEventListener("resize", updateContainerHeight);
    });

    return {
      containerHeight,
      borderBottomHeight,
      ownEventPaneHeight,
      competitorEventPaneHeight,
      universityEventPaneHeight,
      studentTrendPaneHeight,
      extraPaneHeight,
      variableEventPaneMaxHeight,
      variableEventPaneMaxHeightWhenIsShowOtherSide,
      messages
    };
  }
});
